export class Databar {
  title: string;
  row: any[] = [];
  column: any[] = [];
}
